// src/pages/auth/resetpassword.jsx
import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import "./resetpassword.css";

const ResetPassword = () => {
  // 1. Cambia "token" a "code"
  const [searchParams] = useSearchParams();
  const codeParam = searchParams.get("code");
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  // URL de tu backend (Strapi)
  const apiUrl = import.meta.env.VITE_STRAPI_URL || "http://localhost:1337";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (password !== confirmPassword) {
      setError("Las contraseñas no coinciden.");
      return;
    }

    try {
      const res = await fetch(`${apiUrl}/api/auth/reset-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          // 2. Usa "code" en lugar de "token"
          code: codeParam,
          password,
          passwordConfirmation: confirmPassword,
        }),
      });

      const data = await res.json();

      if (res.ok) {
        setMessage("¡Contraseña actualizada con éxito! Ahora puedes iniciar sesión.");
        // Redirige a login después de 3 segundos
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      } else {
        setError(data.error?.message || "Error al restablecer la contraseña.");
      }
    } catch (err) {
      console.error(err);
      setError("Error al conectar con el servidor.");
    }
  };

  return (
    <div className="reset-container">
      <div className="reset-card">
        <h2 className="reset-title">Restablecer Contraseña</h2>
        {/* Verifica si tenemos el parámetro "code" */}
        {codeParam ? (
          <form onSubmit={handleSubmit} className="reset-form">
            <div className="form-group">
              <label>Nueva Contraseña</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Introduce tu nueva contraseña"
                required
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label>Confirmar Contraseña</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirma tu nueva contraseña"
                required
                className="form-control"
              />
            </div>
            {error && <p className="error-message">{error}</p>}
            {message && <p className="success-message">{message}</p>}
            <button type="submit" className="submit-button">
              Restablecer Contraseña
            </button>
          </form>
        ) : (
          // Si no hay "code" o es inválido, muestra mensaje
          <div>
            <p>El enlace de restablecimiento no es válido o ha expirado.</p>
            <Link to="/forgot-password" className="submit-button">
              Solicitar nuevo enlace
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;